export default __webpack_public_path__ + "static/media/Boots of the Haunter in the Dark.e2ecef7b.jpg";